import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MenuIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.52 7.22V5.38H19.48V7.22H4.52ZM4.52 12.88V11.04H19.48V12.88H4.52ZM4.52 18.54V16.7H19.48V18.54H4.52Z" />
    </SvgIcon>
  );
});
